import React from 'react';
import './site_footer.css'
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebook, FaPinterest, FaYoutube } from "react-icons/fa";
// App Store button images (placeholders)
const appStoreImage = "https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg";
const googlePlayImage = "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png";

// CSS is now embedded directly within the component to resolve the import error.

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        {/* Top Section: Company Info */}
        <div className="footer-about">
          <h2 className="footer-heading">Wedstra -India’s Complete Wedding Planning Marketplace</h2>
          <p className="footer-text">
            Plan Your Dream Wedding with Ease
            Wedstra is India’s modern Wedding Planning platform designed to make your special day stress-free and unforgettable. From discovering the finest wedding vendors to exploring trending ideas, everything you need is just a click away.

            <p>Looking for the best wedding planners, photographers, makeup artists, or decorators? Want inspiration for themes, outfits, or destinations? We’ve got it all covered.</p>

            <p>With curated vendor profiles, transparent pricing, genuine reviews, and easy-to-use planning tools like checklists, inspiration boards, and guides – Wedstra brings everything together in one place.</p>

            <p>No more endless calls, confusing choices, or overwhelming stress. Plan your dream wedding effortlessly, save time, and make every decision with confidence – only with Wedstra</p>
          </p>
        </div>

        {/* Main Grid Section */}
        <div className="footer-links-grid">

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-subheading">Contact us</h3>
            <div className="footer-contact-details">
              <div>
                <a href="mailto:contact@example.com">Wedstra.suport@gmail.com</a>
              </div>
            </div>
          </div>

          {/* Follow Us */}
          <div className="footer-section">
            <h3 className="footer-subheading">Follow us</h3>
            <ul className="footer-social-links space-y-2">
              <li>
                <a href="#" className="flex items-center gap-2" style={{ fontSize:"16px"}}>
                  <FaInstagram className='follow-us-icon'/> Instagram
                </a>
              </li>
              <li>
                <a href="#" className="flex items-center gap-2" style={{ fontSize:"16px"}}>
                  <FaFacebook className='follow-us-icon' /> Facebook
                </a>
              </li>
              <li>
                <a href="#" className="flex items-center gap-2" style={{ fontSize:"16px"}}>
                  <FaPinterest className='follow-us-icon' /> Pinterest
                </a>
              </li>
              <li>
                <a href="#" className="flex items-center gap-2" style={{ fontSize:"16px"}}>
                  <FaYoutube className='follow-us-icon'/> Youtube
                </a>
              </li>
            </ul>
          </div>

          {/* Get The App */}
          <div className="footer-section footer-app-section">
            <h3 className="footer-subheading">Get The WEDSTRA app</h3>
            <div className="footer-app-buttons">
              <a href="#" aria-label="Placeholder App Store">
                <img src={googlePlayImage} alt="Placeholder" style={{ width: "200px", height: "80px" }} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="footer-bottom">
          <Link to={'/vendor-register'}>
            <button className="footer-vendor-button">
              Register as a Vendor
            </button>
          </Link>
        </div>

      </div>
    </footer>
  );
}

